// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 1095) return "static/chunks/1095-5bd075fe390cd0cb.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 2937 ? "eabe11fc" : chunkId) + "." + {"156":"90645f005527ea28","2937":"0a588ce09fb27a14"}[chunkId] + ".js";
};